export default function isMobileApp () {
  return window.Capacitor && window.Capacitor.isNative
}
